import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlateValidatorService {
  
  private platePattern = /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/;

  isValidPlate(plate: string): boolean {
    return this.platePattern.test(plate);
  }

  areAllPlatesValid(plates: string[]): boolean {
    return plates.every(plate => plate === '' || this.isValidPlate(plate));
  }

  hasAtLeastOneValidPlate(plates: string[]): boolean {
    return plates.some(plate => this.isValidPlate(plate));
  }
}